import { atom } from 'recoil'
import { IAlarmSituation } from './alarmSituations.types.ts'

interface IAlarmSituationsState {
  items: IAlarmSituation[]
}

const alarmSituationsAtom = atom<IAlarmSituationsState>({ key: 'alarmSituations', default: { items: [] } })
export default alarmSituationsAtom
